// utils
import { getColor } from "../../../../utils/getColor";

import { IFactorComparisonPoint } from "../../schema";

const Config = {
	DATASET_OPTIONS: {
		pointRadius: 4,
		borderWidth: 0,
		hoverBorderWidth: 0,
		pointBackgroundColor: getColor("primary", 5),
	},
	DEFAULT_AXIS_OPTIONS: {
		grid: {
			drawTicks: false,
			color: getColor("neutral", 1),
		},
		border: {
			color: getColor("neutral", 1),
			width: 1,
		},
		ticks: {
			stepSize: 1,
			padding: 8,
			font: {
				size: 12,
				family: "Source Sans Pro, sans-serif",
			},
		},
	},
	/**
	 * Config function to get the color of a point based on its eNPS score
	 */
	getPointColor: (value: IFactorComparisonPoint) => {
		// currently toggled off (PY-2831) awaiting design revision
		// to add legend or more info to custom tooltip
		const eNPSColorizable = false; // value?.eNPSScore || value?.eNPSScore === 0;
		if (!eNPSColorizable) {
			return getColor("primary", 5);
		} else if (value?.eNPSScore && value.eNPSScore > 8) {
			return getColor("green", 5);
		} else if (value?.eNPSScore && value.eNPSScore > 6) {
			return getColor("yellow", 5);
		} else {
			return getColor("red", 5);
		}
	},
};

export default Config;
